import React, { useEffect, useState, useRef } from 'react';
import cn from 'classnames';

import './timelineHorizontally.scss';
import Header from '../header';
import Footer from '../footer';

function TimelineHorizontally(props) {
  const { progress, setCurrentDate, anchor, setEndOne, show } = props;

  const [isMob, setIsMob] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth > 768) {
        setIsMob(false);
      } else {
        setIsMob(true);
      }
      const resizeThrottler = () => {
        if (window.innerWidth < 768) {
          setIsMob(true);
        } else {
          setIsMob(false);
        }
      };

      window.addEventListener('resize', resizeThrottler, false);
    }
  }, []);

  return (
    <>
      <section className={cn('timeline-horizontally timeline__timeline-horizontally', !show && "timeline-horizontally--hide")}>
        <Header components="tm" setCurrentDate={setCurrentDate} />

        <div className="timeline-horizontally__container">
          <div className="timeline-horizontally__list">
            {/* <div className="timeline-horizontally__item" style={{ height: '100%' }}></div> */}
            <div
              className="timeline-horizontally__item timeline-horizontally__item--month-6"
              id="m2007">
              <div className="timeline-horizontally__col timeline-horizontally__col--6-1">
                <span
                  className={cn(
                    'timeline-horizontally__month _anim _fade',
                    // progress > 0.048 &&
                    //   'animate__fadeInRight animate__duration-5s animate__delay-1s',
                  )}>
                  Июнь
                </span>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--6-2">
                <svg
                  className="_tl-bg _tl-bg--1"
                  style={{
                    transform: `translate3d(calc(${progress * 3000}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-1"></use>
                </svg>
                <svg
                  className="_tl-bg _tl-bg--2"
                  style={{
                    transform: `translate3d(calc(${progress * 3500}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-2"></use>
                </svg>
                <svg
                  className="_tl-bg _tl-bg--3"
                  style={{
                    transform: `translate3d(calc(${progress * 4000}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-3"></use>
                </svg>
                <div
                  className={cn(
                    'timeline-horizontally__title _title _anim _fadeLeft',
                    // progress > 0.048 && 'animate__fadeInRight animate__duration-5s ',
                  )}>
                  &laquo;Авито&raquo; как гибрид сайта частных объявлений и онлайн-аукциона
                </div>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--6-3">
                {!isMob && (
                  <>
                    <div
                      className={cn(
                        'note timeline-horizontally__note _anim _fadeLeft ',
                        // progress > 0.0295 && 'animate__fadeInRight',
                        // progress > 0.08 && 'animate__fadeOutLeft',
                      )}
                      data-da=".timeline-horizontally__col--6-6, 767, 1">
                      <div className="note__text _small-text">
                        Филип и Йонас шутят, что юрлицо компании — «КеХ еКоммерц» (Kontakt East
                        Holding AB) — связано с печеньем. Возвращаясь из Швеции, Филип и Йонас часто
                        привозили печенье местной марки KeH и угощали им весь офис.{' '}
                      </div>
                    </div>
                  </>
                )}

                <div
                  className={cn(
                    'timeline-horizontally__img-wrap animate__animated ',
                    // progress > 0.0195 && 'animate__fadeInRight',
                    // progress > 0.065 && 'animate__fadeOutLeft',
                  )}>
                  <div className="timeline-horizontally__img _anim _zoomWrap">
                    <img
                      src="/img/timeline-1-1.png"
                      srcSet="/img/timeline-1-1.png 1x, /img/timeline-1-1@2x.png 2x"
                      alt="img"
                      className="img _anim _zoom"
                    />
                  </div>
                  <p className="timeline-horizontally__caption _small-text _anim _fade">
                    Первые сотрудники «Авито» работали из офиса справочника
                    &laquo;Желтые&nbsp;страницы&raquo;
                  </p>
                </div>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--6-4">
                <p
                  className={cn(
                    'timeline-horizontally__text timeline-horizontally__text--1 _text _anim _fadeLeft',
                    // progress > 0.04 && 'animate__fadeInRight',
                    // progress > 0.1 && 'animate__fadeOutLeft',
                  )}>
                  Бывшие коллеги по Tradera.com отказались работать с молодым программистом из
                  Стокгольма Йонасом в России и он ищет новых. В партнёров ему прочат Филипа
                  Энгельберта — инвестбанкира, в портфеле которого российские «Жёлтые страницы».
                </p>
                <p
                  className={cn(
                    'timeline-horizontally__text timeline-horizontally__text--2 _text _anim _fadeLeft',
                    // progress > 0.06 && 'animate__fadeInRight',
                    // progress > 0.11 && 'animate__fadeOutLeft',
                  )}>
                  Йонас уже однажды пересекался с Филипом на семейном ужине брата: два шведа в
                  России сразу поладили и договорились строить «Авито» вместе.
                </p>
                {isMob && (
                  <>
                    <div
                      className={cn(
                        'note timeline-horizontally__note _anim _fadeLeft',
                        // progress > 0.1 && 'animate__fadeInRight',
                        // progress > 0.15 && 'animate__fadeOutLeft',
                      )}
                      data-da=".timeline-horizontally__col--6-4, 767">
                      <p className="note__text _small-text">
                        Бизнес стартовал ни шатко ни валко: в 2007 году интернет-рынок был сильно
                        перегрет, толковых специалистов найти оказалось непросто.
                      </p>
                    </div>
                  </>
                )}
                <svg
                  className="_tl-bg _tl-bg--4"
                  style={{
                    transform: `translate3d(calc(${progress * 5000}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-4"></use>
                </svg>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--6-5">
                <div
                  className={cn(
                    'timeline-horizontally__img-wrap animate__animated',
                    // progress > 0.08 && 'animate__fadeInRight',
                    // progress > 0.13 && 'animate__fadeOutLeft',
                  )}>
                  <div className="timeline-horizontally__img timeline-horizontally__img--1 _anim _zoomWrap">
                    <img
                      src="/img/timeline-1-2.png"
                      srcSet="/img/timeline-1-2.png 1x, /img/timeline-1-2@2x.png 2x"
                      alt="img"
                      className="img"
                    />
                  </div>
                  <p className="timeline-horizontally__caption _small-text _anim _fade">
                    Йонас Нордландер
                  </p>
                </div>
                <div
                  className={cn(
                    'timeline-horizontally__img-wrap animate__animated',
                    // progress > 0.09 && 'animate__fadeInRight',
                    // progress > 0.14 && 'animate__fadeOutLeft',
                  )}>
                  <div className="timeline-horizontally__img timeline-horizontally__img--2 _anim _zoomWrap">
                    <img
                      src="/img/timeline-1-3.png"
                      srcSet="/img/timeline-1-3.png 1x, /img/timeline-1-3@2x.png 2x"
                      alt="img"
                      className="img"
                    />
                  </div>
                  <p className="timeline-horizontally__caption _small-text _anim _fade">
                    Филип Энгельберт
                  </p>
                </div>
                <svg
                  className="_tl-bg _tl-bg--5"
                  style={{
                    transform: `translate3d(calc(${progress * 4000}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-5"></use>
                </svg>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--6-6">
                {!isMob && (
                  <>
                    <div
                      className={cn(
                        'note timeline-horizontally__note _anim _fadeLeft',
                        // progress > 0.1 && 'animate__fadeInRight',
                        // progress > 0.15 && 'animate__fadeOutLeft',
                      )}
                      data-da=".timeline-horizontally__col--6-4, 767">
                      <p className="note__text _small-text">
                        Бизнес стартовал ни шатко ни валко: в 2007 году интернет-рынок был сильно
                        перегрет, толковых специалистов найти оказалось непросто.
                      </p>
                    </div>
                  </>
                )}

                <p
                  className={cn(
                    'timeline-horizontally__text _text _anim _fadeLeft',
                    // progress > 0.1 && 'animate__fadeInRight',
                    // progress > 0.16 && 'animate__fadeOutLeft',
                  )}>
                  Красивые доменные имена в то время или были заняты, или стоили состояние. Пришлось
                  искать любое звонкое название — даже если оно казалось бессмысленным. Так
                  наткнулись на «Авито».
                </p>
                {isMob && (
                  <>
                    <div
                      className={cn(
                        'note timeline-horizontally__note _anim _fadeLeft ',
                        // progress > 0.0295 && 'animate__fadeInRight',
                        // progress > 0.08 && 'animate__fadeOutLeft',
                      )}
                      data-da=".timeline-horizontally__col--6-6, 767, 1">
                      <div className="note__text _small-text">
                        Филип и Йонас шутят, что юрлицо компании — «КеХ еКоммерц» (Kontakt East
                        Holding AB) — связано с печеньем. Возвращаясь из Швеции, Филип и Йонас часто
                        привозили печенье местной марки KeH и угощали им весь офис.{' '}
                      </div>
                    </div>
                  </>
                )}
                <svg
                  className="_tl-bg _tl-bg--6"
                  style={{
                    transform: `translate3d(calc(${progress * 5000}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-6"></use>
                </svg>
              </div>
            </div>
            <div
              className="timeline-horizontally__item timeline-horizontally__item--month-9"
              id="m2008">
              <div className="timeline-horizontally__col timeline-horizontally__col--9-1">
                <span className="timeline-horizontally__month _anim _fadeLeft">Сентябрь</span>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--9-2">
                <div className="timeline-horizontally__title _large-text _anim _fadeLeft">
                  Шведские инвестфонды <span className="_ab">AB Kinnevik</span> и{' '}
                  <span className="_vn">Vostok Nafta</span> выкупают контрольный пакет акций и
                  выделяют первый транш в <span className="_bg _bg--green">$10 млн</span>
                </div>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--9-3">
                <p className="timeline-horizontally__text _text _anim _fadeLeft">
                  Кризис пришелся на руку: среди тех, кто лишился работы, много опытных
                  профессионалов. Из них «Авито» собирает крепкую команду разработчиков.
                </p>
                <svg
                  className="_tl-bg _tl-bg--7"
                  style={{
                    transform: `translate3d(calc(${progress * 1000}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-7"></use>
                </svg>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--9-4">
                <div className="timeline-horizontally__img-wrap">
                  <div className="timeline-horizontally__img _anim _zoomWrap">
                    <img
                      src="/img/timeline-1-4.png"
                      srcSet="/img/timeline-1-4.png 1x, /img/timeline-1-4@2x.png 2x"
                      alt="img"
                      className="img"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="timeline-horizontally__item timeline-horizontally__item--month-6-1"
              id="m2009">
              <div className="timeline-horizontally__col timeline-horizontally__col--6-1-1">
                <span className="timeline-horizontally__month _anim _fadeLeft">Июнь</span>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--6-1-2">
                <div className="timeline-horizontally__title _title _anim _fadeLeft">
                  Новым директором <span className="_bg _bg--red">по разработке</span> становится
                  Роман Павлушко
                </div>
                <svg
                  className="_tl-bg _tl-bg--8"
                  style={{
                    transform: `translate3d(calc(${progress * 800}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-8"></use>
                </svg>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--6-1-3">
                <p className="timeline-horizontally__text _text _anim _fadeLeft">
                  Павлушко очень удивился, впервые увидев код «Авито»: это был маленький сайт,
                  сделанный за полгода одним человеком. Павлушко привел в «Авито» бывших коллег из
                  веб-студии am.ru, они занялись разработкой нового ПО.
                </p>
                <div className="quote timeline-horizontally__quote _anim _fadeLeft">
                  <div className="quote__content">
                    <p className="quote__text _text">
                      Наша задача тогда была обойти <br /> &laquo;Из&nbsp;рук в&nbsp;руки&raquo;.
                      На&nbsp;irr.ru было 8&nbsp;тысяч просмотров в&nbsp;минуту&nbsp;&mdash; намного
                      больше,&nbsp;чем у&nbsp;&laquo;Авито&raquo;
                    </p>
                  </div>
                  <div className="quote__caption">
                    <div className="quote__caption-img">
                      <img
                        src="/img/roman.png"
                        srcSet="/img/roman.png 1x, /img/roman@2x.png 2x"
                        alt="img"
                        className="img"
                      />
                    </div>
                    <span className="quote__caption-text">Роман Павлушко</span>
                  </div>
                </div>
                <svg
                  className="_tl-bg _tl-bg--9"
                  style={{
                    transform: `translate3d(calc(${progress * 1500}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-9"></use>
                </svg>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--6-1-4">
                <div className="note timeline-horizontally__note _anim _fadeLeft">
                  <p className="note__text _small-text">Aудитория «Авито» тогда достигает</p>
                  <p className="note__main">3,4 млн пользователей</p>
                  <p className="note__text _small-text">
                    А у лидера рынка «Из рук в руки» — 3,8 млн человек.
                  </p>
                </div>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--6-1-5">
                <div className="quote quote--purple timeline-horizontally__quote _anim _fadeLeft">
                  <div className="quote__content">
                    <p className="quote__text _text">
                      В&nbsp;2009&nbsp;мы спросили себя: что такое &laquo;Авито&raquo;? <br /> Для
                      чего мы&nbsp;существуем? Ответ: мы&nbsp;помогаем решить проблему б/у вещей.
                      Если кто-то хочет продать гитару, он&nbsp;должен идти
                      на&nbsp;&laquo;Авито&raquo;. Но&nbsp;какой в&nbsp;этом смысл, если там
                      не&nbsp;будет покупателей гитар? запустили ТВ-рекламу и&nbsp;буквально
                      за&nbsp;одну ночь &laquo;Авито&raquo; стал &laquo;чем-то&raquo;
                      из&nbsp;&laquo;ничего&raquo;. Это было невероятно!
                    </p>
                  </div>
                  <div className="quote__caption">
                    <div className="quote__caption-img">
                      <img
                        src="/img/filip.png"
                        srcSet="/img/filip.png 1x, /img/filip@2x.png 2x"
                        alt="img"
                        className="img"
                      />
                    </div>
                    <span className="quote__caption-text">Филип Энгельберт</span>
                  </div>
                </div>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--6-1-6">
                <div className="timeline-horizontally__title _title _anim _fadeLeft">
                  Сколько стоит ваш беспорядок?
                </div>
                <div className="timeline-horizontally__img timeline-horizontally__img--1 _anim _zoom">
                  <img
                    src="/img/timeline-1-5.png"
                    srcSet="/img/timeline-1-5.png 1x, /img/timeline-1-5@2x.png 2x"
                    alt="img"
                    className="img"
                  />
                </div>
                <div className="timeline-horizontally__img timeline-horizontally__img--2 _anim _zoom">
                  <img
                    src="/img/timeline-1-6.png"
                    srcSet="/img/timeline-1-6.png 1x, /img/timeline-1-6@2x.png 2x"
                    alt="img"
                    className="img"
                  />
                </div>
                <p className="timeline-horizontally__text _text _anim _fadeLeft">
                  В&nbsp;начале года &laquo;Авито&raquo; запускает первую в&nbsp;своем роде
                  рекламную кампанию на&nbsp;ТВ со&nbsp;слоганом &laquo;Сколько стоит ваш
                  беспорядок?&raquo;. Ролик показывал типовую российскую квартиру
                  с&nbsp;развешанными на&nbsp;всех предметах ценниками.
                </p>
                <svg
                  className="_tl-bg _tl-bg--10"
                  style={{
                    transform: `translate3d(calc(${progress * 1200}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-10"></use>
                </svg>
                <svg
                  className="_tl-bg _tl-bg--11"
                  style={{
                    transform: `translate3d(calc(${progress * 1200}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-11"></use>
                </svg>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--6-1-7">
                <div className="timeline-horizontally__title _title _anim _fadeLeft">$800 000</div>
                <p className="timeline-horizontally__text _text _anim _fadeLeft">
                  стоимость рекламной кампании
                </p>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--6-1-8">
                <div className="note timeline-horizontally__note _anim _fadeLeft">
                  <p className="note__text _small-text">
                    Ежемесячная аудитория «Авито» выростает до
                  </p>
                  <p className="note__main">10 млн посетителей</p>
                  <p className="note__text _small-text">
                    Просмотры выросли — в 16 раз, количество объявлений — в 7 раз.
                  </p>
                  <p className="note__text _small-text">
                    В итоге по узнаваемости «Авито» обогонал «Из рук в руки» примерно в 2 раза.
                  </p>
                </div>
                <svg
                  className="_tl-bg _tl-bg--12"
                  style={{
                    transform: `translate3d(calc(${progress * 1000}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-12"></use>
                </svg>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--6-1-9">
                <div className="quote timeline-horizontally__quote _anim _fadeLeft">
                  <div className="quote__content">
                    <p className="quote__text _text">
                      Мы&nbsp;понимали, что ТВ-реклама обойдётся дорого. Но&nbsp;нам нужно было
                      объяснить: все в&nbsp;наших домах стоит денег и&nbsp;мы&nbsp;в&nbsp;любой
                      момент можем это выгодно продать.
                    </p>
                  </div>
                  <div className="quote__caption">
                    <div className="quote__caption-img">
                      <img
                        src="/img/ionas.png"
                        srcSet="/img/ionas.png 1x, /img/ionas@2x.png 2x"
                        alt="img"
                        className="img"
                      />
                    </div>
                    <span className="quote__caption-text">Йонас Нордландер</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="timeline-horizontally__item timeline-horizontally__item--month-4">
              <div className="timeline-horizontally__col timeline-horizontally__col--4-1">
                <span className="timeline-horizontally__month _anim _fadeLeft">Апрель</span>
                <div className="note timeline-horizontally__note _anim _fadeLeft">
                  <p className="note__text _small-text">
                    Помимо России, «Авито» начал работать в Украине через сайт torg.ua.
                  </p>
                </div>
                <svg
                  className="_tl-bg _tl-bg--13"
                  style={{
                    transform: `translate3d(calc(${progress * 1000}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-13"></use>
                </svg>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--4-2">
                <p className="timeline-horizontally__text timeline-horizontally__text--1 _text _anim _fadeLeft">
                  Отказавшись от идеи искать инвесторов в России, «Авито» снова находит их в Швеции.
                  В компанию вкладываются фонды Investment AB Kinnevik и Northzone Ventures.
                </p>
                <p className="timeline-horizontally__text timeline-horizontally__text--2 _text _anim _fadeLeft">
                  Чтобы догнать «Из рук в руки», «Авито» скупает поисковой трафик, в том числе по
                  редким запросам. Трафик стоит недешево: по 1,5-2 рубля за клик.
                </p>
                <svg
                  className="_tl-bg _tl-bg--14"
                  style={{
                    transform: `translate3d(calc(${progress * 900}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-14"></use>
                </svg>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--4-3">
                <div className="note timeline-horizontally__note  _anim _fadeLeft">
                  <p className="note__main">$26 млн</p>
                  <p className="note__text _small-text">
                    вложили шведские фонды в развитие «Авито»
                  </p>
                </div>
                <svg
                  className="_tl-bg _tl-bg--15"
                  style={{
                    transform: `translate3d(calc(${progress * 900}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-15"></use>
                </svg>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--4-4">
                <div className="timeline-horizontally__img  _anim _zoomWrap">
                  <picture>
                    <source
                      srcSet="/img/timeline-1-7-mob.png 1x, /img/timeline-1-7-mob.png 2x"
                      media="(max-width: 767px)"
                    />
                    <img
                      src="/img/timeline-1-7.png"
                      srcSet="/img/timeline-1-7.png 1x, /img/timeline-1-7@2x.png 2x"
                      alt="img"
                      className="img"
                    />
                  </picture>
                </div>
              </div>
            </div>
            <div
              className="timeline-horizontally__item timeline-horizontally__item--month-9-1"
              id="m2010">
              <div className="timeline-horizontally__col timeline-horizontally__col--9-1-1">
                <span className="timeline-horizontally__month _anim _fadeLeft">Сентябрь</span>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--9-1-2">
                <div className="timeline-horizontally__title _title _anim _fadeLeft">
                  Всё началось с&nbsp;котят и&nbsp;щенков
                </div>
                <p className="timeline-horizontally__text _text _anim _fadeLeft">
                  Вторым и более позитивным индикатором успеха стал поток объявлений о продаже котят
                  и щенков на «Авито». Поначалу он не очень-то обрадовал администрацию сайта — ну
                  какой же это бизнес? А потом Йонас во время перелета рейсом «Аэрофлота» прочитал в
                  бортовом журнале, что Россия — вторая в мире страна по количеству домашних
                  животных после США.{' '}
                </p>
                <svg
                  className="_tl-bg _tl-bg--16"
                  style={{
                    transform: `translate3d(calc(${progress * 800}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-16"></use>
                </svg>
                <svg
                  className="_tl-bg _tl-bg--17"
                  style={{
                    transform: `translate3d(calc(${progress * 800}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-17"></use>
                </svg>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--9-1-3">
                <div className="quote quote--green timeline-horizontally__quote _anim _fadeLeft">
                  <div className="quote__content">
                    <p className="quote__text _text">
                      Мы решили этим воспользоваться и вложили деньги, чтобы привлечь покупателей, а
                      за ними пришло еще больше продавцов – люди стали писать в интернете про
                      «Авито», где можно продать кошек и собак. С этого все началось
                    </p>
                  </div>
                  <div className="quote__caption">
                    <div className="quote__caption-img">
                      <img
                        src="/img/ionas.png"
                        srcSet="/img/ionas.png 1x, /img/ionas@2x.png 2x"
                        alt="img"
                        className="img"
                      />
                    </div>
                    <span className="quote__caption-text">Йонас Нордландер</span>
                  </div>
                </div>
                <p className="timeline-horizontally__text timeline-horizontally__text--1 _text _anim _fadeLeft">
                  Вокруг каждой кошки или собаки есть целая семья, а где семья, там и вещи, и деньги
                  — так что это очень хорошо — обрадовался Йонас.
                </p>
                <p className="timeline-horizontally__text timeline-horizontally__text--2 _text _anim _fadeLeft">
                  Все эти объявления фактически стали первой бизнес-вертикалью «General/Товары
                  повседневного спроса».
                </p>
                <svg
                  className="_tl-bg _tl-bg--18"
                  style={{
                    transform: `translate3d(calc(${progress * 700}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-18"></use>
                </svg>
              </div>
            </div>
            <div
              className="timeline-horizontally__item timeline-horizontally__item--month-2"
              id="m2011">
              <div className="timeline-horizontally__col timeline-horizontally__col--2-1">
                <span className="timeline-horizontally__month _anim _fadeLeft">Февраль</span>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--2-2">
                <div className="timeline-horizontally__title _large-text _anim _fadeLeft">
                  У «Авито» появляется мобильная версия сайта и приложение для iPhone
                </div>
                <p className="timeline-horizontally__text _text  _anim _fadeLeft">
                  Спустя 11 лет с мобильных устройств заходят до 80% посетителей.
                </p>
                <div className="note timeline-horizontally__note  _anim _fadeLeft">
                  <p className="note__text _small-text">
                    «Авито» открывает второй офис — Центр клиентского сервиса в Симферополе
                  </p>
                </div>
                <svg
                  className="_tl-bg _tl-bg--19"
                  style={{
                    transform: `translate3d(calc(${progress * 600}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-19"></use>
                </svg>
                <svg
                  className="_tl-bg _tl-bg--20"
                  data-da=".timeline-horizontally__col--2-6,767"
                  style={{
                    transform: `translate3d(calc(${progress * 600}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-20"></use>
                </svg>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--2-3">
                <div className="timeline-horizontally__img  _anim _zoomWrap">
                  <img
                    src="/img/timeline-1-8.png"
                    srcSet="/img/timeline-1-8.png 1x, /img/timeline-1-8@2x.png 2x"
                    alt="img"
                    className="img"
                  />
                </div>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--2-4">
                <div className="note timeline-horizontally__note  _anim _fadeLeft">
                  <p className="note__text _small-text">
                    {' '}
                    «Авито» вошёл в ТОП-5 самых посещаемых ресурсов Рунета: ежемесячная аудитория
                    составила около 20 млн уникальных пользователей
                  </p>
                </div>
                <svg
                  className="_tl-bg _tl-bg--21"
                  style={{
                    transform: `translate3d(calc(${progress * 500}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-21"></use>
                </svg>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--2-5">
                <div className="timeline-horizontally__title _title  _anim _fadeLeft">
                  За&nbsp;год аудитория <br /> платформы выросла на <br /> <span>10&nbsp;млн</span>
                  &nbsp;пользователей
                </div>
                <svg
                  className="_tl-bg _tl-bg--22"
                  style={{
                    transform: `translate3d(calc(${progress * 500}px), 0px, 0px)`,
                  }}>
                  <use href="/img/icons/icons.svg#_tl-bg-22"></use>
                </svg>
              </div>
              <div className="timeline-horizontally__col timeline-horizontally__col--2-6">
                <p className="timeline-horizontally__text _text  _anim _fadeLeft">
                  «Авито» берет курс на работу с малым и средним бизнесом. Платформа запускает
                  «Авито Магазин», где профессиональные продавцы создают собственные витрины с
                  товарами.
                </p>
                <svg className="_tl-bg _tl-bg--23">
                  <use href="/img/icons/icons.svg#_tl-bg-23"></use>
                </svg>
              </div>
            </div>
            <div className="timeline-horizontally__item timeline-horizontally__item--end">
              <div className="timeline-horizontally__col">
                <div className="timeline-horizontally__title _title  _anim _fadeLeft">
                  2012-2016
                </div>
                <div className="timeline-horizontally__subtitle  _anim _fadeLeft">
                  Большой прорыв
                </div>
                <p className="timeline-horizontally__text _text  _anim _fadeLeft">
                  Когда показатели взлетают, работать приходится ещё больше
                </p>
                <button className="timeline-horizontally__btn _anim _fadeLeft" onClick={() => setEndOne(true)}>Читать далее</button>
              </div>
              <img
                src="/img/icons/_tl-bg-24.svg"
                className="_tl-bg _tl-bg--24"
                style={{
                  transform: `translate3d(calc(${progress * 200}px), 0px, 0px)`,
                }}
              />
              <img
                src="/img/icons/_tl-bg-25.svg"
                className="_tl-bg _tl-bg--25"
                style={{
                  transform: `translate3d(calc(${progress * 150}px), 0px, 0px)`,
                }}
              />
              <img
                src="/img/icons/_tl-bg-26.svg"
                className="_tl-bg _tl-bg--26"
                style={{
                  transform: `translate3d(calc(${progress * 50}px), 0px, 0px)`,
                }}
              />
            </div>
          </div>
        </div>
        <Footer components="tm" />
      </section>
    </>
  );
}

export default TimelineHorizontally;
